import { Controller } from "@hotwired/stimulus"
import Glide from '@glidejs/glide'

export default class extends Controller {

    connect() {
        
        const sliders = document.querySelectorAll('.glide')
        const conf = {
            type: 'carousel',
            gap: 16,
            perView: 1.2,
            rewind: false,
        }

        if(sliders.length !== 0) {
            sliders.forEach(item => {
                new Glide(item, conf).mount()
            })
        }
    }
}
